angular
    .module('TR')
    .directive('imageLoader', function() {
        return {
            restrict: 'A',
            scope: {
                onload : '&',
                onerror : '&'
            },
            link(scope:ng.IScope, element:ng.IAugmentedJQuery, attrs) {
                element.on('load', () => {
                    scope.onload({name:attrs.name});
                });
                element.on('error', () => {
                    scope.onerror({name:attrs.name});
                });
            }
        };
    });
